import { FormRow } from '@zocdoc-frontend-common/styles-grid';
import Row from '@zocdoc-frontend-common/styles-grid/components/Row';
import { Radio, RadioGroup } from '@zocdoc-frontend-common/components-radio';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { blue100, slate30 } from '@zocdoc-mezzanine/foundations-colors';
import { FontFamily } from '@zocdoc-frontend-common/styles-typography';
import ErrorMessage from '@zocdoc-frontend-common/components-errormessage';

export default class GenderPicker extends Component {
    static propTypes = {
        onChange: PropTypes.func.isRequired,
        error: PropTypes.bool,
    };

    render() {
        const { onChange, error } = this.props;
        return (
            <FormRow>
                <FormLabel>Sex</FormLabel>

                <Row
                    className="exclude-from-playback"
                    data-test="sex-picker-container"
                >
                    <RadioGroup
                        className="exclude-from-playback"
                        data-test="create-account-sex-picker"
                        hasError={error}
                        name="sex"
                        onChangeCallback={value => onChange('gender', value)}
                        orientation="horizontal"
                    >
                        <StyledRadio
                            data-test="radio-male"
                            data-uem-id="radio-male"
                            text="Male"
                            value="male"
                        />

                        <StyledRadio
                            data-test="radio-female"
                            data-uem-id="radio-female"
                            text="Female"
                            value="female"
                        />
                    </RadioGroup>
                </Row>
                {this.maybeRenderSexErrorText()}
            </FormRow>
        );
    }

    maybeRenderSexErrorText = () => {
        const { error } = this.props;
        if (error) {
            return (
                <Row>
                    <ErrorMessage data-test="sex-error">
                        Please select a sex.
                    </ErrorMessage>
                </Row>
            );
        }
    };
}

const StyledRadio = styled(Radio)`
    width: 50%;
    border-right: solid 1px ${slate30};
`;

const FormLabel = styled.div`
    color: ${blue100};
    font: 15px/24px ${FontFamily.SharpSansSemibold};
`;
